
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 22 24"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M2 13.875h12.667L8.333 2 2 13.875zm14.431-.94a2 2 0 01-1.764 2.94H2a2 2 0 01-1.765-2.94L6.57 1.058a2 2 0 013.529 0l6.333 11.875z"}}),_c('path',{attrs:{"d":"M9 17.365h2.238A5.5 5.5 0 1016.008 9L14.99 7.06A7.5 7.5 0 119 17.365z"}})])
          )
        }
      }
    